import {Button, ConfirmDialog, useDialog} from 'platform/components';
import {Box, Heading, HStack} from 'platform/foundation';

import {i18n} from '@dms/i18n';

import {suffixTestId, TestIdProps} from 'shared/web';

interface ComparisonPageHeaderProps extends TestIdProps {
  isLoading: boolean;
  isDeleting: boolean;
  onDelete: () => void;
}

export function ComparisonPageHeader(props: ComparisonPageHeaderProps) {
  const [isDialogOpen, openDialog, closeDialog] = useDialog();

  return (
    <>
      <Box
        paddingHorizontal={4}
        paddingVertical={2}
        backgroundColor="palettes.neutral.20.100"
        borderBottom="1px solid"
        borderColor="general.separator"
        position="sticky"
        left={0}
      >
        <HStack align="center" justify="space-between">
          <Heading alternative size={2}>
            {i18n.t('entity.vehicle.labels.comparisonPage')}
          </Heading>
          <Button
            variant="secondary"
            title={i18n.t('general.actions.deleteList')}
            leftIcon="action/delete_outline"
            isDisabled={props.isLoading}
            isLoading={props.isDeleting}
            onClick={openDialog}
            data-testid={suffixTestId('deleteButton', props)}
          />
        </HStack>
      </Box>

      <ConfirmDialog
        text={`${i18n.t('general.actions.deleteList')}?`}
        onConfirm={props.onDelete}
        onClose={closeDialog}
        isOpen={isDialogOpen}
        data-testid={suffixTestId('deleteDialog', props)}
      />
    </>
  );
}
